import { ComponentType, lazy } from 'react';

const NEVER_SETTLES = new Promise<never>(() => {});

// When a deploy invalidates a chunk, `vite:preloadError` is prevented and the import resolves with `undefined`
// while the page reloads: keep Suspense on its fallback until unload instead of throwing on the missing module.
export const lazyPage = <M, P = Record<string, never>>(load: () => Promise<M>, pick: (module: M) => ComponentType<P>) =>
  lazy(() => load().then((module) => (module ? { default: pick(module) } : NEVER_SETTLES)));
